import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var more_horizontal_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M11 13h2v-2h-2v2zm-6 0h2v-2H5v2zm12-2v2h2v-2h-2z" }) });
export {
  more_horizontal_default as default
};
//# sourceMappingURL=more-horizontal.js.map
